module.exports = __webpack_public_path__ + "images/drawbotics-a1204fc8ee8d009f51f249f391fb0fe9.jpg";